import styled from 'styled-components'
import { Modal } from 'antd'

const AntModalStyled = styled(Modal)``

export default AntModalStyled
